import { Component, Inject, OnInit } from '@angular/core';
import { AdminProyectoEducativoComponent } from '../../reportes/components/admin-proyecto-educativo/admin-proyecto-educativo.component';

@Component({
  selector: 'app-simulacion-pei',
  templateUrl: './simulacion-pei.component.html',
  styleUrls: ['./simulacion-pei.component.css']
})
export class SimulacionPeiComponent implements OnInit {

  constructor(
    @Inject(AdminProyectoEducativoComponent) private parent: AdminProyectoEducativoComponent
  ) { }

  ngOnInit(): void {
  }

  volver(){
    this.parent.ngOnInit();
  }
}
